import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { CampaignValidationService, CampaignValidationResult } from '../services/campaign-validation.service';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class CampaignGuard implements CanActivate {
  private campaignValidationService = inject(CampaignValidationService);
  private storageService = inject(StorageService);
  private router = inject(Router);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    // First check URL query params for short code
    let shortCode = route.queryParams['s'] || route.queryParams['short'] || null;
    
    // If no short code in URL, check localStorage for stored value
    if (!shortCode) {
      shortCode = this.storageService.getSync('short');
      console.log('🛡️ CampaignGuard: No shortCode in URL, checking localStorage:', shortCode);
      console.log('🛡️ CampaignGuard: Direct localStorage check:', localStorage.getItem('short'));
    } else {
      console.log('🛡️ CampaignGuard: Found shortCode in URL:', shortCode);
    }
    
    console.log('🛡️ CampaignGuard: Validating campaign for shortCode:', shortCode);
    
    const validation: CampaignValidationResult = await this.campaignValidationService.validateCampaign(shortCode);
    
    if (validation.isValid) {
      console.log('✅ CampaignGuard: Campaign is valid, allowing access');
      return true;
    }

    console.log('❌ CampaignGuard: Campaign validation failed, redirecting to error page', validation);
    
    // Navigate to campaign error page with validation details
    this.router.navigate(['/campaign-error'], {
      queryParams: {
        status: validation.status,
        message: validation.message,
        shortCode: validation.shortCode || '',
        actions: JSON.stringify(validation.suggestedActions || [])
      }
    });
    
    return false;
  }
}
